<template>
  <div>
    <div class="home">
      <!-- 轮播图 -->
      <div class="block">
        <el-carousel :interval="2000">
          <el-carousel-item
            v-for="item in lbUrl"
            :key="item.id"
          >
            <div class="lb">
              <img
                class="lb_img"
                :src="item.img"
                alt=""
              >
              <img
                :src="item.stake"
                alt=""
                class="stake"
              >
              <div class="banner_T">
                <div
                  class="title"
                  v-html="item.title"
                />
                <div class="subtitle">
                  {{ item.subtitle }}
                </div>
                <div
                  class="button"
                  @click="contactUs(item.url)"
                >
                  <div>
                    {{ item.button }}
                    <img
                      src="@/assets/home/project.png"
                      alt=""
                    >
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 安全产品 -->
      <div
        id="anchor6"
        class="meau_style"
        style="padding-top: 80px"
      >
        <div class="title">
          安全产品
        </div>
        <el-divider />

        <div class="subtitle">
          SAFETY PRODUCTS
        </div>
        <div class="products_content">
          <div class="lists">
            <div
              v-for="product in products"
              :key="product.id"
              class="list"
              @click="expect(product.url)"
            >
              <img
                :src="product.imgUrl"
                alt=""
              >
              <el-divider />
              <div class="name">
                <div v-html="product.productName" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 安全服务 -->
      <div
        id="anchor1"
        class="meau_style bgColor"
      >
        <div class="title">
          安全服务
        </div>
        <el-divider />
        <div class="subtitle">
          SECURITY SERVICES
        </div>
        <div class="services_content">
          <div class="lists">
            <div
              v-for="services in servicesList"
              :key="services.id"
              class="list"
            >
              <img
                :src="services.imgUrl"
                alt=""
              >
              <div class="name">
                {{ services.servicesName }}
              </div>
              <div
                v-for="(route, routeIndex) in services.contents"
                :key="routeIndex"
                class="route_list"
              >
                <p @click="routeLick(route.url)">
                  {{ route.name }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="anchor2"
        class="meau_style bgImg"
      >
        <div class="title">
          应用场景及技术解决方案
        </div>
        <el-divider />
        <div class="subtitle">
          APPLICATION SCENARIOS AND TECHNICAL SOLUTIONS
        </div>
        <div class="solutions">
          <div class="solutions_title">
            <div @click="isShow = 1">
              行业应用场景
            </div>
            <div @click="isShow = 2">
              技术解决方案
            </div>
          </div>
        </div>
        <div class="industry_technology">
          <div class="industry">
            <div class="show_img">
              <img
                v-if="isShow == 1"
                src="@/assets/home/project.png"
                alt=""
              >
            </div>
            <div :class="isShow == 1 ? 'lists' : 'lists1'">
              <div
                v-for="(industry, industryIndex) in industryList"
                :key="industryIndex"
                class="list"
                @click="routLink(industry.url)"
              >
                <img
                  :src="industry.imgUrl"
                  alt=""
                >
                <div class="industryName">
                  <p>{{ industry.industryName }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="technology">
            <div class="show_img">
              <img
                v-if="isShow == 2"
                src="@/assets/home/project.png"
                alt=""
              >
            </div>
            <div :class="isShow == 2 ? 'lists' : 'lists1'">
              <div
                v-for="(technology, technologyIndex) in technologyList"
                :key="technologyIndex"
                class="list"
                @click="routLink(technology.url)"
              >
                <img
                  :src="technology.imgUrl"
                  alt=""
                >
                <div class="technologyName">
                  <div v-html="technology.technologyName" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 服务客户 -->
      <div
        class="meau_style bgColor"
        style="margin-top: -99px"
      >
        <div class="title">
          服务客户
        </div>
        <el-divider />
        <div class="subtitle">
          OUR ADVANTAGE
        </div>
        <div class="customer_content">
          <img
            src="@/assets/home/customer.png"
            alt=""
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Home',
  data() {
    return {
      isShow: 1,
      // 轮播图
      lbUrl: [
        {
          id: 1,
          title: '灵创科技<br/>陪伴您的网络安全守护者',
          subtitle: '集安全产品、安全运营、安全服务的综合性解决方案厂商',
          button: '项目咨询',
          img: require('@/assets/home/banner1.jpg'),
          stake: require('@/assets/home/people.png'),
          url: '/contact'
        },
        {
          id: 2,
          title: '灵创科技<br/>陪伴您的网络安全守护者',
          subtitle: '集安全产品、安全运营、安全服务的综合性解决方案厂商',
          button: '项目咨询',
          img: require('@/assets/home/banner1.jpg'),
          stake: require('@/assets/home/people.png'),
          url: '/contact'
        },
        {
          id: 3,
          title: '灵创科技<br/>陪伴您的网络安全守护者',
          subtitle: '集安全产品、安全运营、安全服务的综合性解决方案厂商',
          button: '项目咨询',
          img: require('@/assets/home/banner1.jpg'),
          stake: require('@/assets/home/people.png'),
          url: '/contact'
        }
      ],
      // 安全产品
      products: [
        {
          id: 1,
          productName: '网络空间资产<br/>风险感知系统',
          imgUrl: require('@/assets/home/product1.png'),
          url: '/camasPro'
        },
        {
          id: 2,
          productName: '网络安全应急<br/>工具箱系统',
          imgUrl: require('@/assets/home/product2.png'),
          url: '/emergencyToolbox'
        },
        {
          id: 3,
          productName: '网络安全及信息化<br/>能力提升系统',
          imgUrl: require('@/assets/home/product3.png'),
          url: '/informationization'
        },
        {
          id: 4,
          productName: '信息化及安全<br/>服务量化系统',
          imgUrl: require('@/assets/home/product4.png'),
          url: '/expect'
        },
        {
          id: 5,
          productName: '网络协议端口<br/>识别系统',
          imgUrl: require('@/assets/home/product5.png'),
          url: '/expect'
        },
        {
          id: 6,
          productName: '互联网漏洞<br/>扫描分析系统',
          imgUrl: require('@/assets/home/product6.png'),
          url: '/expect'
        },
        {
          id: 7,
          productName: '网络安全资产<br/>运行维护管理系统',
          imgUrl: require('@/assets/home/product7.png'),
          url: '/expect'
        },
        {
          id: 8,
          productName: '自动化流程<br/>编排系统',
          imgUrl: require('@/assets/home/product8.png'),
          url: '/expect'
        }
      ],
      // 安全服务
      servicesList: [
        {
          id: 1,
          imgUrl: require('@/assets/home/services1.png'),
          servicesName: '安全评估',
          contents: [
            {
              name: '风险评估',
              url: '/risk'
            },
            {
              name: '渗透测试',
              url: '/seep'
            },

            {
              name: '安全检查',
              url: '/inspect'
            },
            {
              name: '代码审计',
              url: '/audit'
            }
          ]
        },
        {
          id: 2,
          imgUrl: require('@/assets/home/services2.png'),
          servicesName: '咨询规划及培训',
          contents: [
            {
              name: '安全意识培训',
              url: '/realize'
            },
            {
              name: '行业安全咨询',
              url: '/sector'
            },
            {
              name: '安全体系规划设计',
              url: '/planning'
            },
            {
              name: '安全技术培训',
              url: '/training'
            }
          ]
        },
        {
          id: 3,
          imgUrl: require('@/assets/home/services3.png'),
          servicesName: '重保应急',
          contents: [
            {
              name: '安全监测',
              url: '/monitor'
            },
            {
              name: '安全巡检',
              url: '/inspection'
            },
            {
              name: '安全通告',
              url: '/notify'
            },
            {
              name: '重保值守',
              url: '/guardAgain'
            },
            {
              name: '应急响应',
              url: '/emergency'
            }
          ]
        },
        {
          id: 4,
          imgUrl: require('@/assets/home/services4.png'),
          servicesName: '安全运营',
          contents: [
            {
              name: '安全运营的需求',
              url: '/safeOperation',
              anchor: '#anchor1'
            },
            {
              name: '安全运营周期',
              url: '/safeOperation',
              anchor: '#anchor2'
            },
            {
              name: '安全运营体系框架图',
              url: '/safeOperation',
              anchor: '#anchor3'
            },
            {
              name: '安全运营建设清单',
              url: '/safeOperation',
              anchor: '#anchor4'
            }
          ]
        },
        {
          id: 5,
          imgUrl: require('@/assets/home/services5.png'),
          servicesName: '攻防演练',
          contents: [
            {
              id: 51,
              name: '演习方案设计',
              url: '/attackDrill',
              anchor: '#anchor1'
            },
            {
              id: 52,
              name: '攻防演习组织形式',
              url: '/attackDrill',
              anchor: '#anchor2'
            },
            {
              id: 53,
              name: '服务流程',
              url: '/attackDrill',
              anchor: '#anchor3'
            },
            {
              id: 54,
              name: '攻防演习价值',
              url: '/attackDrill',
              anchor: '#anchor4'
            }
          ]
        }
      ],
      industryList: [
        {
          imgUrl: require('@/assets/home/industry1.png'),
          industryName: '医疗',
          url: '/medicalCare'
        },
        {
          imgUrl: require('@/assets/home/industry2.png'),
          industryName: '关键基础设施',
          url: '/infrastructure'

        },
        {
          imgUrl: require('@/assets/home/industry3.png'),
          industryName: '企业',
          url: '/enterprise'

        },
        {
          imgUrl: require('@/assets/home/industry4.png'),
          industryName: '政府',
          url: '/government'

        }
      ],
      technologyList: [
        {
          imgUrl: require('@/assets/home/technology1.png'),
          technologyName: '等级保护建设方案',
          url: '/gradeProtection'
        },
        {
          imgUrl: require('@/assets/home/technology2.png'),
          technologyName: '数据安全解决方案',
          url: '/dataSecurity'
        },
        {
          imgUrl: require('@/assets/home/technology3.png'),
          technologyName: '系统安全加固方案',
          url: '/systemSecurityReinforcement'
        },
        {
          imgUrl: require('@/assets/home/technology4.png'),
          technologyName: '主机安全加固方案',
          url: '/hostSecurityReinforcement'
        },
        {
          imgUrl: require('@/assets/home/technology5.png'),
          technologyName: '终端一体化解决方案',
          url: '/terminalIntegration'
        },
        {
          imgUrl: require('@/assets/home/technology6.png'),
          technologyName: '安全运营解决方案简约版',
          url: '/simpleVersionOfSafeOperation'
        },
        {
          imgUrl: require('@/assets/home/technology7.png'),
          technologyName: '跨网交换解决方案',
          url: '/crossNetworkSwitching'
        },
        {
          imgUrl: require('@/assets/home/technology8.png'),
          technologyName: '全流量安全监测分析服务解决方案',
          url: '/fullFlowSafety'
        }
      ]
    }
  },
  mounted() { },
  created() {
    if (this.$route.query.anchor) {
      setTimeout(() => {
        this.goAnchor(this.$route.query.anchor)
      }, 1000)
    }
  },
  methods: {
    goAnchor(selector) {
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    routerPage(con) {
      if (con.anchor) {
        this.$router.push({
          path: con.url,
          query: {
            anchor: con.anchor
          }
        })
      } else {
        this.$router.push(con.url)
      }
    },
    // 项目咨询跳转到联系我们
    contactUs(url) {
      sessionStorage.setItem('activeIndex', '5')
      this.$router.push(url)
    },
    // 敬请期待
    expect(url) {
      sessionStorage.setItem('activeIndex', '2')
      this.$router.push(url)
    },
    // 安全服务跳转
    routeLick(url) {
      sessionStorage.setItem('activeIndex', '3')
      this.$router.push(url)
    },
    // 应用场景跳转
    routLink(url) {
      sessionStorage.setItem('activeIndex', '4')
      this.$router.push(url)
    },
    // 新闻详情
    moreDetail(index) {
      var detail = this.$router.resolve({
        path: '/newsdetail',
        query: {
          id: index
        }
      })
      window.open(detail.href, '_blank')
    }
  }
}
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  min-width: 1200px;

  .block {
    width: 100%;
    height: 100vh;
    position: relative;

    .el-carousel--horizontal {
      height: 100%;
    }

    ::v-deep .el-carousel__container {
      height: 100%;
    }

    .lb {
      height: 100%;

      .stake {
        position: absolute;
        right: 10%;
        top: 20%;
        width: 35%;
        height: auto;
      }
    }

    .banner_T {
      position: absolute;
      top: 15%;
      left: 15%;

      .title {
        width: 80%;
        font-size: 54px;
        color: #333333;
        font-weight: bold;
      }

      .subtitle {
        width: 80%;
        font-size: 30px;
        color: #333333;
        margin-top: 50px;
      }

      .button {
        margin-top: 50px;
        width: 164px;
        background: #2d6af5;
        color: #333333;
        display: flex;
        align-items: center;
        border-radius: 12px;
        color: #fff;
        cursor: pointer;

        div {
          margin: 10px auto;
          font-size: 20px;
          text-align: center;
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: auto;
            margin-left: 8px;
          }
        }
      }
    }

    .lb_img {
      width: 100%;
      // height: auto;
      height: 100%;
      position: relative;
    }
  }

  .meau_style {
    width: 100%;
    margin: 0 auto;

    // margin-top: 120px;
    .title {
      color: #333333;
      font-size: 40px;
      text-align: center;
      font-weight: bold;
    }

    .el-divider--horizontal {
      width: 119px;
      height: 2px;
      background: #2d6af5;
      margin: 0 auto;
      margin-top: 36px;
      border-radius: 1px;
    }

    .subtitle {
      margin-top: 22px;
      font-size: 24px;
      color: #666666;
      text-align: center;
    }
  }

  .products_content {
    width: 70%;
    margin: 0 auto;
    margin-top: 48px;
    box-shadow: 0 0 10px 15px #fbfafa;

    .lists {
      width: 100%;
      padding: 62px 0;
      margin: 62px auto;
      display: flex;
      // flex-wrap: wrap;
      background: #fff;
      text-align: center;
      margin-top: 30px;
      flex-wrap: wrap;
      justify-content: space-evenly;

      .list {
        width: 19%;
        padding: 0 20px 0;
        margin: 0 1% 4%;
        cursor: pointer;

        img {
          width: 144px;
          height: 149px;
          align-items: center;
        }

        .el-divider--horizontal {
          width: 47px;
          height: 3px;
          background: #bebebe;
          margin: 0 auto;
          margin-top: 36px;
          border-radius: 1px;
        }

        .name {
          margin-top: 18px;
          font-size: 25px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;

          div {
            text-align: center;
          }
        }
      }
    }

    .list:hover {
      transform: scale(1.02, 1.02);

      .el-divider--horizontal {
        background: #2d71f6;
      }

      .name {
        color: #2d71f6;
      }
    }
  }

  .bgColor {
    width: 100%;
    margin-top: 99px;
    background: #fafbff;

    .title {
      padding-top: 117px;
    }
  }

  .services_content {
    width: 100%;
    background: #fafbff;

    .lists {
      width: 70%;
      margin: 0 auto;
      padding: 20px 0;
      display: flex;
      flex-wrap: wrap;
      text-align: center;
      margin-top: 30px;

      .list {
        width: 16%;
        padding: 33px 20px 30px;
        margin: 33px 0.1% 30px;

        img {
          width: 70px;
          height: 92px;
          align-items: center;
        }

        .name {
          margin-top: 18px;
          font-size: 26px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;

          div {
            text-align: center;
          }
        }

        .route_list {
          font-size: 18px;
          color: #666666;

          p {
            cursor: pointer;
          }

          p:hover {
            color: #426ef3;
            font-weight: bold;
          }
        }
      }

      .list:hover {
        background: #fff;
        box-shadow: 0 0 10px 15px #fbfafa;
      }
    }
  }

  .customer_content {
    width: 70%;
    margin: 98px auto 0;
    padding-bottom: 80px;
    background: #fafafa;

    img {
      width: 100%;
      height: auto;
    }
  }

  .bgImg {
    width: 100%;
    min-height: 900px;
    margin-top: 0;
    margin-bottom: 0;
    background-image: url('~@/assets/home/solutions.png');
    background-size: 100% 100%;

    .title {
      padding-top: 119px;
    }
  }

  .solutions {
    margin-top: 76px;

    .solutions_title {
      width: 80%;
      margin: 0 auto;
      color: #333333;
      font-size: 28px;
      display: flex;
      justify-content: space-around;

      div:nth-child(1) {
        width: 50%;
        text-align: center;
        margin-left: 50px;
        cursor: pointer;
      }

      div:nth-child(2) {
        width: 50%;
        text-align: center;
        margin-right: 50px;
        cursor: pointer;
      }
    }
  }

  .industry_technology {
    width: 70%;
    margin: 17px auto 63px;
    display: flex;
    justify-content: space-around;

    .industry {
      width: 50%;

      .show_img {
        width: 93%;
        height: 80px;
        margin-bottom: -30px;
        text-align: center;

        img {
          width: 60px;
          height: 80px;
          transform: rotate(270deg);
        }
      }

      .lists {
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        padding: 20px 0 0 20px;
        background: #fff;
      }

      .lists1 {
        width: 90%;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        padding: 20px 0 0 20px;
      }

      .list {
        width: 46.5%;
        padding: 0 20px 0 0;
        cursor: pointer;
        position: relative;

        .industryName {
          position: absolute;
          top: 46%;
          left: 0;
          right: 0;

          p {
            text-align: center;
            font-size: 24px;
            color: #fff;
            opacity: 0.8;
          }
        }

        img {
          width: 100%;
          height: 135px;
          align-items: center;
          margin-bottom: 10px;
        }

        .name {
          margin-top: 18px;
          font-size: 26px;
          font-weight: bold;
          color: #333333;
          line-height: 40px;

          div {
            text-align: center;
          }
        }
      }
    }

    .technology {
      width: 50%;

      .show_img {
        width: 102%;
        height: 80px;
        margin-bottom: -30px;
        text-align: center;

        img {
          width: 60px;
          height: 80px;
          transform: rotate(270deg);
        }
      }

      .lists {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        padding: 20px 0 0 20px;
        background: #fff;
      }

      .lists1 {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        text-align: center;
        padding: 20px 0 0 20px;
      }

      .list {
        width: 24%;
        cursor: pointer;
        position: relative;

        img {
          width: 90%;
          height: 130px;
          align-items: center;
          margin-bottom: 10px;
        }

        .technologyName {
          position: absolute;
          bottom: 22px;
          left: 0;
          right: 0;
          width: 90%;
          margin: 0 auto;

          div {
            font-size: 20px;
            color: #fff;
            opacity: 0.8;
          }
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .home .industry_technology .industry .list {
    width: 45.6% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }

  .home .products_content .lists .list {
    width: 18%;
  }
}

@media (max-width: 1550px) {
  .home .services_content .lists .list {
    width: 15%;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .home .products_content .lists .list .name{
    font-size: 19px;
  }
  .home .industry_technology .industry .list {
    width: 45% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;
      width: 100%;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .home .services_content .lists .list .name {
    font-size: 22px;
  }

  .home .services_content .lists .list .route_list {
    font-size: 17px;
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }

  .home .products_content .lists .list {
    width: 18%;
  }

  .home .block .banner_T .title {
    font-size: 40px;
  }

  .home .block .banner_T .subtitle {
    font-size: 22px;
    margin-top: 35px;
  }

  .home .block .banner_T {
    top: 10%;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1300px) {

  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }
}

@media screen and (min-width: 1300px) and (max-width: 1400px) {
  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }

  .home .services_content .lists .list .name {
    font-size: 23px;
  }

  .home .industry_technology .industry .list {
    width: 45% !important;

    .industryName {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }

  .home .products_content .lists .list {
    width: 18%;
  }

  .home .block .banner_T .title {
    font-size: 50px;
  }

  .home .block .banner_T .subtitle {
    font-size: 28px;
    margin-top: 35px;
  }

  .home .block .banner_T {
    top: 10%;
  }
}

@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .home .products_content .lists{
   width: 100% !important;
  }
  .home .services_content .lists .list .name {
    font-size: 24px;
  }

  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }

  .home .industry_technology .industry .list {
    width: 45.3% !important;

    .industryName {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }

  .home .block .banner_T .title {
    font-size: 50px;
  }

  .home .block .banner_T .subtitle {
    font-size: 28px;
    margin-top: 35px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1600px) {
  .home .services_content .lists .list .name {
    font-size: 24px;
  }

  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }

  .home .industry_technology .industry .list {
    width: 45% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }

  .home .products_content .lists .list {
    width: 18% !important;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1700px) {
  .home .products_content .lists{
   width: 100% !important;
  }
  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }

  .home .industry_technology .industry .list {
    width: 44.5% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }
}

@media screen and (min-width: 1700px) and (max-width: 1800px) {
  /deep/.el-carousel__arrow--left {
    left: 16px;
    top: 48%;

  }

  /deep/.el-carousel__arrow--right {
    right: 16px;
    top: 48%;

  }

  .home .industry_technology .industry .list {
    width: 46% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }
}

@media screen and (min-width: 1800px) and (max-width: 1900px) {
  .home .industry_technology .industry .list {
    width: 46% !important;

    .industryName {
      position: absolute;
      top: 48%;
      left: 0;
      right: 0;

      p {
        text-align: center;
        font-size: 20px;
        color: #fff;
        opacity: 0.8;
      }
    }
  }

  .technologyName {
    max-height: 100px;
    overflow-y: scroll;
    font-size: 12px;
  }

  /* for Chrome */
  .technologyName::-webkit-scrollbar {
    display: none;
  }
}
</style>
